import { useState } from 'react';

interface PayoutMethod {
  method: string;
  speed: string;
  hours: number;
}

const methods: PayoutMethod[] = [
  { method: 'PayPal', speed: 'Instant', hours: 0 },
  { method: 'Skrill', speed: 'Instant', hours: 0 },
  { method: 'Bank Transfer', speed: '24-48 hours', hours: 36 },
  { method: 'Visa/Mastercard', speed: '1-3 days', hours: 48 },
];

export const PayoutSpeedCheck: React.FC = () => {
  const [selectedMethod, setSelectedMethod] = useState(methods[0]);

  const maxHours = 72;
  const barWidth = ((maxHours - selectedMethod.hours) / maxHours) * 100;

  return (
    <div className="glass-card p-6">
      <h3 className="text-2xl font-bold text-primary-green mb-4">Payout Speed Check</h3>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">
            Payment Method
          </label>
          <select
            value={selectedMethod.method}
            onChange={(e) => {
              const method = methods.find(m => m.method === e.target.value);
              if (method) setSelectedMethod(method);
            }}
            className="w-full bg-black/50 border border-primary-green/30 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-primary-green"
          >
            {methods.map(method => (
              <option key={method.method} value={method.method}>
                {method.method} - {method.speed}
              </option>
            ))}
          </select>
        </div>
        <div className="pt-4">
          <div className="flex justify-between text-sm text-gray-400 mb-2">
            <span>Processing Time</span>
            <span className="text-primary-green font-bold">{selectedMethod.speed}</span>
          </div>
          <div className="w-full bg-gray-800 rounded-full h-6 overflow-hidden">
            <div
              className="h-full bg-gradient-to-r from-primary-green to-primary-lightgreen transition-all duration-500"
              style={{ width: `${barWidth}%` }}
            />
          </div>
          <p className="text-xs text-gray-500 mt-2">
            {selectedMethod.hours === 0 
              ? 'Instant processing available' 
              : `Average processing time: ${selectedMethod.hours} hours`}
          </p>
        </div>
      </div>
    </div>
  );
};

